export default "__VITE_ASSET__BwZ54A$Y__"